export default __webpack_public_path__ + "static/media/fs_icon26.92001e32.svg";